module.exports = __webpack_public_path__ + "static/favicon-abbd5cf6b6f239d13e9afff2c3abe317.ico";